export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_9.adac5347.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};